import { Button, useDisclosure } from '@chakra-ui/react';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';

import { SlugToNameProvider } from 'packages/dataPipeline/hooks/slugToNameContext';
import { UploadDrawer } from 'packages/dataPipeline/ui/uploads/UploadDrawer';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';

export const UploadDrawerButton = ({
  buttonText,
  creditFacilityId,
  reportingDate,
}: {
  buttonText: string;
  creditFacilityId?: string;
  reportingDate?: Util.FullDateStr;
}) => {
  const { user } = useUserAuthOrThrow();
  const flags = useFeatureFlags();
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (flags.productsDataPipelinePermissions !== 'allow') {
    return null;
  }

  return (
    <>
      <Button variant="secondary" colorScheme="v2-aurora" onClick={onOpen}>
        {buttonText}
      </Button>
      {isOpen && (
        <SlugToNameProvider organizationId={user.organizationId}>
          <UploadDrawer
            organizationId={user.organizationId}
            onClose={onClose}
            creditFacilityId={creditFacilityId}
            reportingDate={reportingDate}
          />
        </SlugToNameProvider>
      )}
    </>
  );
};
